"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var NBTActionButtons = function NBTActionButtons(_ref) {
  var showError = _ref.showError,
    submitBtnText = _ref.submitBtnText,
    selectPlanRedirect = _ref.selectPlanRedirect;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showError && /*#__PURE__*/_react.default.createElement("div", {
    className: "submit-error"
  }, /*#__PURE__*/_react.default.createElement("span", null, "ERROR: not able to submit application.")), /*#__PURE__*/_react.default.createElement("div", {
    className: "nbt-confirm-cta navigation"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "data-test-id": "confirm-and-apply",
    type: "submit",
    className: "btn primary lcps-button"
  }, submitBtnText), selectPlanRedirect && /*#__PURE__*/_react.default.createElement("div", {
    className: "choose-another-option"
  }, /*#__PURE__*/_react.default.createElement("div", null, "or"), /*#__PURE__*/_react.default.createElement("a", {
    href: selectPlanRedirect
  }, /*#__PURE__*/_react.default.createElement("span", {
    "data-test-id": "back-to-offers"
  }, "Choose another option")))));
};
NBTActionButtons.propTypes = {
  showError: _propTypes.default.bool.isRequired,
  submitBtnText: _propTypes.default.string.isRequired,
  selectPlanRedirect: _propTypes.default.string.isRequired
};
var _default = NBTActionButtons;
exports.default = _default;
